import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MapComponentsProvider, getTheme } from "@mapcomponents/react-maplibre";
import { AppContextProvider } from "./context/AppContext";
import { DataContextProvider } from "./context/DataContext";

import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material";
import { SearchContextProvider } from "./context/SearchContext";
import { MapPointContextProvider } from "./context/MapPointContext";
import { BrowserRouter } from "react-router-dom";

export const defaultTheme = createTheme(getTheme(), {
    palette: {
        secondary: { main: "#ffffff" },
        layers: {
            apt: "#3C79E5",
            not_apt: "#f51212",
            not_defined: "#e8852e",
            protectedAreas: "#9ddb90",
            GLöZ2Areas: "#e3f11a",
            GLöZ2Line: "#cccccc",
            NUT2Line: "#e0283e",
            line_list_selected: "#FFFF00",
            line_list_unselected: "#ff00d2",
        },
    },
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider theme={defaultTheme}>
                <MapComponentsProvider>
                    <MapPointContextProvider>
                        <DataContextProvider>
                            <AppContextProvider>
                                <SearchContextProvider>
                                    <App />
                                </SearchContextProvider>
                            </AppContextProvider>
                        </DataContextProvider>
                    </MapPointContextProvider>
                </MapComponentsProvider>
            </ThemeProvider>
        </BrowserRouter>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
